import { render, staticRenderFns } from "./CourseTest.vue?vue&type=template&id=c7c0b72e&scoped=true&"
import script from "./CourseTest.vue?vue&type=script&lang=ts&"
export * from "./CourseTest.vue?vue&type=script&lang=ts&"
import style0 from "./CourseTest.vue?vue&type=style&index=0&id=c7c0b72e&lang=scss&scoped=true&"
import style1 from "./CourseTest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c0b72e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCard,VCheckbox,VContent})
